/** @format */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'fe-styled-components';
import theme from 'fe-appdir-lib-theme';

const PROP_TYPES = {
  header: PropTypes.node,
  items: PropTypes.arrayOf(PropTypes.node).isRequired,
};

const Container = styled.div`
  margin-bottom: ${theme.spacingXxl};
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;

  @media (min-width: ${theme.breakpointMd}) {
    margin-bottom: calc(${theme.spacingXxl} * 2);
  }

  @supports (display: grid) {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    grid-auto-rows: auto;
    grid-row-gap: ${theme.verticalRhythmBase};
    grid-column-gap: ${theme.verticalRhythmBase};
  }
`;

const HeaderWrapper = styled.div`
  flex: 1 1 auto;

  @supports (display: grid) {
    grid-column: 1 / -1;
    margin: 0;
  }
`;

const Item = styled.div`
  flex: 1 0 33%;
  flex-grow: 1;
  margin: ${theme.verticalRhythmHalf};

  @media (min-width: ${theme.breakpointSm}) {
    max-width: calc(100% - ${theme.verticalRhythmBase});
  }
  @media (min-width: ${theme.breakpointMd}) {
    max-width: calc(50% - ${theme.verticalRhythmBase});
  }
  @media (min-width: ${theme.breakpointLg}) {
    max-width: calc(33% - ${theme.verticalRhythmBase});
  }

  @supports (display: grid) {
    margin: 0;
    max-width: none;
  }
`;

const CuratedCollection = ({ header, items }) => {
  return (
    <Container>
      {header ? <HeaderWrapper>{header}</HeaderWrapper> : null}
      {items.map((item, i) => {
        return (
          <Item key={i} id={`item-${i}`}>
            {item}
          </Item>
        );
      })}
    </Container>
  );
};

CuratedCollection.propTypes = PROP_TYPES;
CuratedCollection.displayName = 'CuratedCollection';

export { CuratedCollection };
